import Login from './login'
import Callback from './callback'
export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
    children: [
      {
        path: '/login/callback',
        component: Callback
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/login/login-router.js